import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "ProductFilterBox" })
export default class ProductFilterBox extends Vue {
    public selectedSchoolTypeFilter: string = (<any>window).App.bag.SelectedSchoolTypeFilter;
    public selectedSchoolLevelFilter: string = (<any>window).App.bag.SelectedSchoolLevelFilter;

    get routes() {
        return (<any>window).App.routes;
    }

    get schoolTypes() {
        return (<any>window).App.bag.SchoolTypes;
    }

    get schoolLevels() {
        return (<any>window).App.bag.SchoolLevels;
    }

    get productListUrl() {
        return (<any>window).App.bag.ProductListUrl;
    }

    public setSchoolTypeValue(typeValue: string) {
        this.setSearch(typeValue, this.selectedSchoolLevelFilter);
    }

    public setSchoolLevelValue(schoolLevelValue: string) {
        this.setSearch(this.selectedSchoolTypeFilter, schoolLevelValue);
    }

    public setSchoolTypeSelected(schoolType: string) {
        if (this.selectedSchoolTypeFilter === schoolType) {
            return true
        } else {
            return false;
        }
    }

    public setSchoolLevelSelected(schoolLevel: string) {
        if (this.selectedSchoolLevelFilter === schoolLevel) {
            return true
        } else {
            return false;
        }
    }

    public setAllButtonSelected(schoolType: string, schoolLevel: string) {
        if (schoolType === "" && schoolLevel === "") {
            return true;
        } else {
            return false;
        }
    }

    public setSearch(schoolTypeFilter: string, schoolLevelFilter: string) {
        let filters = [],
            filterCount = 0,
            queryString = "";

        if (schoolTypeFilter) {
            filters.push("schoolType=" + schoolTypeFilter);
            filterCount++;
        }

        if (schoolLevelFilter) {
            filters.push("schoolLevel=" + schoolLevelFilter);
            filterCount++;
        }

        if (filterCount !== 0) {
            queryString = filters.join("&");
            window.location.href = this.productListUrl + "?" + queryString;
        } else {
            window.location.href = this.productListUrl;
        }
    }
};